import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { AddExistingProductModalContentTemplate } from 'themes/modules/product/pages';
import { AddExistingProductModalContentViewStore } from 'modules/product/stores';

@setCurrentView(
	(rootStore, componentProps) => new AddExistingProductModalContentViewStore(rootStore, componentProps),
	'addExistingProductModalContentViewStore'
)
@observer
class AddExistingProductModalContent extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <AddExistingProductModalContentTemplate {...this.props} />;
	}
}

export default observer(AddExistingProductModalContent);
